/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useUserAccounts } from '../redux/features/user/userAccounts/useUserAccounts';

/**
 * Hook to return the current organization details.
 */
export default function useOrganization() {
  const { user } = useUserAccounts();
  const { currentOrganizationId } = user || {};
  const currentOrganization = user?.groups?.find(group => group.id === currentOrganizationId);

  return currentOrganization;
}
